module.exports = __webpack_public_path__ + "img/banner.28d87f3c.png";